import { render, staticRenderFns } from "./Footprints.vue?vue&type=template&id=45c23b30&scoped=true"
import script from "./Footprints.vue?vue&type=script&lang=js"
export * from "./Footprints.vue?vue&type=script&lang=js"
import style0 from "./Footprints.vue?vue&type=style&index=0&id=45c23b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c23b30",
  null
  
)

export default component.exports